// removed by extract-text-webpack-plugin
module.exports = {"container":"event-link__container__2n5hX","link":"event-link__link__3uiaP","container-meeting-link":"event-link__container-meeting-link__13Jc0","link-with-details":"event-link__link-with-details__3JKPH","thumbnail-container":"event-link__thumbnail-container__iIP2Q","thumbnail-container-meeting-link":"event-link__thumbnail-container-meeting-link__2cq-1","details":"event-link__details__3Mqp6","title":"event-link__title__2uA0b","details-link":"event-link__details-link__3GoEB event-link__link__3uiaP","plain-link":"event-link__plain-link__23rdn event-link__link__3uiaP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-link.scss
// module id = 1338
// module chunks = 1